import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';

import HoverCardContent from './HoverCardContent';

export default function ScheduleShiftHoverCard({
  children,
  placement = 'rightTop',
  ...contentProps
}) {
  return (
    <Popover
      placement={placement}
      trigger="hover"
      mouseEnterDelay={0.2}
      align={{ offset: [0, 0] }}
      overlayClassName="schedule-shift-hover-popover"
      content={<HoverCardContent {...contentProps} />}
    >
      {children}
    </Popover>
  );
}

ScheduleShiftHoverCard.propTypes = {
  children: PropTypes.node.isRequired,
  placement: PropTypes.string,
};

ScheduleShiftHoverCard.defaultProps = {
  placement: 'rightTop',
};
